export const fonts = {
  Times: {
    normal: "Times New Roman.ttf",
    bold: "Times New Roman - Bold.ttf",
    italics: "Times New Roman - Italic.ttf",
  },
};
